module.exports = __webpack_public_path__ + "img/Lulu&Luigi_EGM.4f28a74b.png";